document.addEventListener('DOMContentLoaded', function() {
  const launchButtons = document.querySelectorAll('.product-launch-card button');
  
  launchButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Fix body position
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    });
  });
  
  // Add close functionality to unfix
  const closeButtons = document.querySelectorAll('.modal-close');
  closeButtons.forEach(button => {
    button.addEventListener('click', function() {
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
    });
  });
});
